import React from 'react';

const ImageGalleryJs = () => {
  const images = [
    {
      src: "/projectsimg/Mall-4.png",
      alt: "Shopping mall interior with an oval shape LED ceiling light and plants along the walkway with glass guardrails"
    },
    {
      src: "/projectsimg/Mall-5.png",
      alt: "Modern lobby area with a circular blue sofa surrounding a white artistic tree-like decorative structure"
    },
    {
      src: "https://storage.googleapis.com/workspace-0f70711f-8b4e-4d94-86f1-2a93ccde5887/image/22f6ed39-09f9-4ca8-8ef9-99bf22210f19.png",
      alt: "Mall interior dome ceiling made of triangular panels with a tall palm tree and people walking around"
    }
  ];

  return (
    <div style={{
      margin: 0,
      fontFamily: "'Arial', sans-serif",
      display: 'flex',
      justifyContent: 'center',
      padding: '20px',
      background: '#f9f9f9',
      minHeight: '100vh'
    }}>
      <div 
        className="gallery" 
        role="list"
        style={{
          display: 'flex',
          gap: '20px',
          maxWidth: '1200px',
          width: '100%',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        {images.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            role="listitem"
            tabIndex="0"
            style={{
              width: '100%',
              maxWidth: '350px',
              height: 'auto',
              borderRadius: '4px',
              boxShadow: '0 3px 8px rgb(0 0 0 / 0.15)',
              objectFit: 'cover',
              background: '#ddd',
              transition: 'transform 0.3s ease',
              cursor: 'pointer',
              display: 'block'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 15px rgb(0 0 0 / 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 3px 8px rgb(0 0 0 / 0.15)';
            }}
            onFocus={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 15px rgb(0 0 0 / 0.3)';
            }}
            onBlur={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 3px 8px rgb(0 0 0 / 0.15)';
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://via.placeholder.com/350x200?text=Image+Not+Available';
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageGalleryJs;